export const options = [
  {
    value: '짜증',
  },
  {
    value: '슬픔',
  },
  {
    value: '기쁨',
  },
  {
    value: '곽철용',
  },
  {
    value: '무야호',
  },
];
